import { Column, Entity, PrimaryGeneratedColumn, OneToMany, ManyToMany, JoinTable, OneToOne } from "typeorm"
import { PvpcMap } from "./PvpcMap";
import { User } from "./User";
import { KamiVisibility } from "../../enumerations";
import { Order } from "./Order";
import { ProductPriceOverride } from "./ProductPriceOverride";
import { KamiClient } from "./KamiClient";
import { OverageMonitor } from "./OverageMonitor";

@Entity()
export class Client {

  @PrimaryGeneratedColumn({ name:"id" })
  id?: number;
  
  @Column({nullable : false})
  client_name!: string

  @Column({nullable : false})
  client_xero_name!: string

  @Column({nullable : false})
  client_xero_id!: string

  @Column({nullable : true})
  lolo_id!: string

  @Column({nullable : true})
  lolo_name!: string

  @Column({nullable : true})
  lolo_account_id!: string

  @Column({nullable : true})
  vpn_map_id!: number

  @ManyToMany(() => User, (user:any) => user.clients)
  users!: User[]

  @Column('boolean', {default: false})
  trial!: boolean

  @Column('boolean', {default: true})
  attach_report!: boolean

  @ManyToMany(() => PvpcMap, (pvpc:any) => pvpc.clients)
    @JoinTable()
    pvpcs?: PvpcMap[]

  @Column({nullable : true})
  zoho_overage_ticket_id!: string

  @Column('boolean', {default : false})
  mav_scan!: boolean

  @Column({default : ''})
  mav_scan_additional_clients!: string

  @Column({default : ''})
  mav_scan_port_ranges!: string

  @Column({nullable : true, default : null})
  mav_scan_username!: string

  @Column({nullable : true, default : null})
  mav_scan_password!: string

  @Column({default : KamiVisibility.MARKETING})
  kami_visibility!: KamiVisibility

  @Column({nullable: false, default: ''})
  kami_targets!: string

  @Column({default : '{}'})
  kami_port_ranges_json!: string

  @Column({default : ''})
  kami_notification_emails!: string

  @Column('decimal', {default : 4.95, precision: 6, scale: 2})
  kami_price!: number

  @Column({default : 10})
  kami_global_email_delay!: number

  @OneToMany(() => Order, (order) => order.client)
  orders?: Order[]

  @OneToMany(() => ProductPriceOverride, (ppo) => ppo.client)
  priceOverrides?: ProductPriceOverride[]

  @ManyToMany(() => KamiClient, (kamiClients) => kamiClients.clients)
  @JoinTable()
  kamiClients?: KamiClient[]

  @Column('decimal', {default : 0.6, precision: 14, scale: 4})
  payg_fixed_monthly_charge_initial!: number

  @Column('decimal', {default : 0.03, precision: 14, scale: 4})
  payg_usage_multiplier_charge_initial!: number

  @Column('decimal', {default : 0.6, precision: 14, scale: 4})
  payg_fixed_monthly_charge_ongoing!: number

  @Column('decimal', {default : 0.03, precision: 14, scale: 4})
  payg_usage_multiplier_charge_ongoing!: number

  @Column({default : 1024})
  payg_initial_allowance_mb!: number

  @OneToOne(() => OverageMonitor, (overageMonitor) => overageMonitor.client)
  overage_monitor?: OverageMonitor
}